<template>
  <div class="main">
      <tab :title='nav_name'></tab>
        <div class="top_title">
            账户信息
        </div>
      <div class="top">
          <div class="top_oli">
              司机姓名：{{item.driverName}}
          </div>
          <div class="top_oli">
              手机号码：{{item.mobile}}
          </div>
          <div class="top_oli">
              余额：{{item.balance}}元
          </div>
          <div class="top_oli">
              管控模式：{{item.controlType==1?'受限加注':'不受限'}}
          </div>
          <div class="top_oli">
              油品类型：{{item.qualityModel}}
          </div>
          <div class="top_oli">
              适用站点：{{item.stationList}}
          </div>
          <div class="top_oli">
            状态：<span :class="item.status == 1 ? 'lv' : 'red'">{{
              item.status == 1 ? "启用" : "禁用"
            }}</span>
          </div>
          <div
          class="operation_btn"
          v-if="item.status == 1"
          @click="determineType(item.status, item.id)"
        >
          禁用
        </div>
        <div
          class="operation_btn"
          v-if="item.status == 0"
          @click="determineType(item.status, item.id)"
        >
          启用
        </div>
      </div>
        <div class="top_title">
            账户信息
        </div>
      <div class="bottom">
      <div class="bottom_title">
        可分配余额：<span>{{ balance }}</span>
      </div>
      <div class="bottom_title">
       当前子账户余额：<span>{{item.balance}}</span>
      </div>
      
      <div class="operation_input" @focusout="inputBlur" @focusin="inputFocus">
        <span>{{ inputName }}：</span
        ><input v-model="value" maxlength="5" type="text" />
      </div>
      <div class="choose_btn">
          <span>本次分配方式:</span>
        <div class="fenpei_btn" :id="type==0?'blue':''" @click="chooseType(0)">分配</div>
        <div class="fanfenpei_btn" :id="type==1?'blue':''" @click="chooseType(1)">反分配</div>
      </div>
      <div class="determine_btn" @click="confirm">确定</div>
    </div>
  </div>
</template>

<script>
import tab from '@/components/NavBar'
import Vue from 'vue';
import { Dialog } from 'vant';
import { Toast } from 'vant';

Vue.use(Toast);
export default {
  name: 'margin',
  data () {
    return {
        inputName:'分配金额',
        type:0,
        nav_name:'司机操作',
        balance:0,
        item:[],
        value:''

    }
  },
  components:{
      tab
  },
  watch: {
    value: function(val){
      this.value = val.replace(/\D/g, '')
    }
  },
  mounted(options){
      console.log(this.$route.params.item)
      this.item = this.$route.params.item
      this.balance = this.$storage.get('balance')
  },
  methods:{
    inputBlur(e) {
        if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
          this.timer = setTimeout(() => {
            window.scrollTo(0, 0);
          }, 0);
        }
      },
      inputFocus(e) {
        if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
          clearTimeout(this.timer);
        }
      },
      chooseType(type){
          this.type = type
          if(type==0){//分配
            this.inputName ='分配金额'
            return
          }
          if(type==1){//反分配
            this.inputName ='反分配金额'
            return
          }
      },
      confirm(){
          if(this.type==0){
            var balance = ((this.item.balance-0) + (this.value-0)).toFixed(2)
            var zhanghubalance = (this.$storage.get('balance') - this.value).toFixed(2)
            var text = '分配'
            if ((this.value-0)>(this.balance-0) ) {
              Toast("分配金额不能大于账户余额");
              return;
            }
          }else{
            var balance = ((this.item.balance-0) - (this.value-0)).toFixed(2)
            var zhanghubalance = ((this.$storage.get('balance'))-0 + (this.value-0)).toFixed(2)
            if(balance<0){
                Toast('反分配金额不能大于卡余额');
                return
            }
            var text = '反分配'
          }
          Dialog.confirm({
                title: '温馨提示',
                message: `${text}后司机${this.item.driverName}的余额为${balance}，账户可分配余额为${zhanghubalance}，确认分配？`,
            })
            .then(() => {
                // on confirm
                this.assignCarDriver(zhanghubalance)
            })
            .catch(() => {
                // on cancel
            });
      },
      assignCarDriver(zhanghubalance){
          Toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
          if(this.value==''){
            Toast.clear();
            Toast('请填写操作金额')
            return
          }
          var data = {
              token:this.$storage.get('token'),
              id:this.item.id,
              assignType:this.type,
              assignAmount:this.value
          }

          this.$api.post('orgapp/assignCarDriver',data,response=>{
              console.log(response)
              if(response.status >= 200 && response.status < 300) {
                  var data = response.data
                  if(data.msg=="success"){
                      Toast.clear();
                    Dialog.alert({
                        title: '标题',
                        message: '操作成功！',
                    }).then(() => {
                    // on close
                        this.$storage.set('balance',zhanghubalance)
                        this.$router.go(-1);
                    });

                  }else{
                      Toast.clear();
                      if(data.msg=="token失效，请重新登录"){
                          this.$router.push({
                              name:'login'
                          })
                      }
                  }
              }else{
                  
              }
              
          })
      },
      determineType(type,id){
        if(type==1){//当前状态为启用，点击后执行停用
            //调用接口停用
            var msg = '确认禁用该司机？'
            var status=0
        }
        if(type==0){//当前状态为停用，点击后执行启用
            //调用接口启用
            var msg = '确认启用该司机？'
            var status=1
        }
        Dialog.confirm({
            title: '标题',
            message: msg,
        })
        .then(() => {
            // on confirm
            this.enableCarDriver(id,status)
        })
        .catch(() => {
            // on cancel
        });
    },
    enableCarDriver(id,status){
        var data = {
            token:this.$storage.get('token'),
            id:id,
            status:status
        }
        this.$api.post('orgapp/enableCarDriver',data,response=>{
            if (response.status >= 200 && response.status < 300) {
                console.log(response.data)
                var data = response.data
                if(data.msg=='success'){
                    Toast.success('更改成功！');
                    this.$router.go(-1);
                }else{
                   Toast(data.msg);
                }
            }
        })
    }
  }
}
</script>

<style scoped>
.main {
    background-color: #F7F8FA;
    height: 100vh;
}
.top {
  width: 90%;
  margin: auto;
  border-radius: 5px;
  box-shadow: 5px 5px 5px #eee;
  min-height: 200px;
  background-color: #fff;
  position: relative;
}
.top_oli {
    width: 90%;
    margin: auto;
    height: 30px;
    line-height: 30px;
}
.bottom {
  padding-bottom: 20px;
  width: 90%;
  margin: auto;
  border-radius: 5px;
  box-shadow: 5px 5px 5px #eee;
  background-color: #fff;
}
.bottom_title {
  width: 65%;
  margin: auto;
  text-align: center;
}
.bottom_title span{
    font-size: 24px;
    color:#1989FA;
    height: 40px;
    line-height: 40px;
}
.bottom_name {
    width: 100%;
    line-height: 40px;
    text-align: center;
    font-size: 26px;
}
.choose_btn {
    text-align: center;
  margin: auto;
}
.fenpei_btn {
    width: 69px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    color: #fff;
    border-radius: 3px;
    background-color: #eee;
    display: inline-block;
    margin-right: 39px;
}
.fanfenpei_btn{
    width: 69px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    color: #fff;
    border-radius: 3px;
  background-color: #eee;
    display: inline-block;
}
.operation_input{
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
}
.operation_input input {
      border: none;
  border: 1px solid #000;
  width: 140px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  text-align: center;
}
.determine_btn {
    width: 57%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    margin-top: 15px;
    background-color:#1989FA ;
    font-size: 20px;
}
#lv {
    color: #07C160;
    border-color: #07C160;
}
#red {
    color: #EE0A24;
    border-color: #EE0A24;
}
.lv {
  color: chartreuse;
}
.red {
  color: #fb0606;
}
#blue {
    background-color: #1989FA;
}
.operation_btn {
  width: 62px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: #1989FA;
  border-radius: 4px;
  position: absolute;
  right: 6px;
  color: #fff;
  bottom: 5px;
}
.top_title {
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
}
.carNo {
    font-size: 16px;
    width: 48%;
    border-bottom: 1px solid #eee;
    margin: 0;
    margin-left: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/driver_operation.vue